import { createSlice } from '@reduxjs/toolkit';

export const SignModalSlice = createSlice({
    name : 'signModal',
    initialState: 1,
    reducers: {
        setSignType: (state, action) => action.payload,
    }
})

export const { setSignType } = SignModalSlice.actions
export const signModalSelector = state => state.signModal